import { CategoryTag } from '@catalog/const';
import { StateUtils } from '@spartacus/core';
import { CATEGORY_TAGS, CATEGORY_TAG_ITEM } from '../catalog-state';

export const LOAD_CATEGORY_TAGS = '[CustomCatalog] Category Tags Load';
export const LOAD_CATEGORY_TAGS_SUCCESS = '[CustomCatalog] Category Tags Load Success';
export const LOAD_CATEGORY_TAGS_FAIL = '[CustomCatalog] Category Tags Load Fail';

export const LOAD_CATEGORY_TAG_ITEM = '[CustomCatalog] Category Tag Item Load';
export const LOAD_CATEGORY_TAG_ITEM_SUCCESS = '[CustomCatalog] Category Tag Item Load Success';
export const LOAD_CATEGORY_TAG_ITEM_FAIL = '[CustomCatalog] Category Tag Item Load Fail';
export const CATEGORY_TAG_ITEM_RESET = '[CustomCatalog] Category Tag Item Reset';

export class LoadCategoryTags extends StateUtils.EntityLoadAction {
  readonly type = LOAD_CATEGORY_TAGS;

  constructor(public uid: string) {
    super(CATEGORY_TAGS, uid);
  }
}

export class LoadCategoryTagsSuccess extends StateUtils.EntitySuccessAction {
  readonly type = LOAD_CATEGORY_TAGS_SUCCESS;

  constructor(
    public uid: string,
    public payload: CategoryTag[],
  ) {
    super(CATEGORY_TAGS, uid, payload);
  }
}

export class LoadCategoryTagsFail extends StateUtils.EntityFailAction {
  readonly type = LOAD_CATEGORY_TAGS_FAIL;

  constructor(
    public uid: string,
    payload: any,
  ) {
    super(CATEGORY_TAGS, uid, payload);
  }
}

export class LoadCategoryTagItem extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_CATEGORY_TAG_ITEM;

  constructor(public tagSlug: string) {
    super(CATEGORY_TAG_ITEM);
  }
}

export class LoadCategoryTagItemSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_CATEGORY_TAG_ITEM_SUCCESS;

  constructor(public payload: CategoryTag) {
    super(CATEGORY_TAG_ITEM);
  }
}

export class LoadCategoryTagItemFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_CATEGORY_TAG_ITEM_FAIL;

  constructor(payload: any) {
    super(CATEGORY_TAG_ITEM, payload);
  }
}

export class CategoryTagItemReset extends StateUtils.LoaderResetAction {
  readonly type = CATEGORY_TAG_ITEM_RESET;

  constructor() {
    super(CATEGORY_TAG_ITEM);
  }
}

export type CategoryTagsAction =
  | LoadCategoryTags
  | LoadCategoryTagsSuccess
  | LoadCategoryTagsFail
  | LoadCategoryTagItem
  | LoadCategoryTagItemSuccess
  | LoadCategoryTagItemFail
  | CategoryTagItemReset;
